import { Component, input, effect, output, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Address } from '../../models/address';

@Component({ standalone: false,
    selector: 'app-additional-addresses-table',
    templateUrl: './additional-addresses-table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./additional-addresses-table.component.scss']
  })
  export class AdditionalAddressesTableComponent {

    readonly addresses = input.required<Address[]>();
    readonly readOnly = input<boolean>(true);
    
    readonly deleteAddress = output<Address>();
    readonly editAddress = output<Address>();

    public dataSource!: MatTableDataSource<Address>;

    constructor(){
      effect(() => {
        this.processAddresses();
      });
    }

    get displayedColumns(){
      if(!this.readOnly())
        return ['street', 'city', 'state', 'zip', 'county', 'actions'];
      else
        return ['street', 'city', 'state', 'zip', 'county'];
    }

    private processAddresses(){
      this.dataSource=new MatTableDataSource(this.addresses());
    }

    public onDeleteAddress(adr:Address){
      this.deleteAddress.emit(adr);
    }

    public onEditAddress(adr:Address){
      this.editAddress.emit(adr);
    }
  }